
define('text!templates/modules/conversation/lists/conversation-list-item.html',[],function () { return '<p class="box-title">{{name}}</p>\n<p class="box-subtitle">{{{message}}}</p>\n<p class="box-tinyinfo">{{>date}}</p>\n';});

